import { useState } from "react";
import { accountService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";

const ENTITIES = {
  COMMUNITIES: "communities",
  HOMES: "homes",
  BUILDERS: "builders",
};

export const useManageContactRelationshipsViewModel = () => {
  const [contactCategories, setContactCategories] = useState([]);
  const stateManager = useComponentState();
  const isLoading = stateManager.isBusy();

  const loadData = () => {
    stateManager.run(async () => {
      // FIX:ME smplify this logic to use getAll once endpoint is available
      const categoires = await Promise.all(
        Object.values(ENTITIES).map(async (entity) => {
          const response = await accountService.contactCategories.getByType({
            type: entity,
          });
          if (response.status === HTTP_STATUSES.OK) {
            return {
              object: entity,
              relationshipInUse: response.data.filter((data) => data.isActive)
                .length,
            };
          }
          return {
            object: entity,
            relationshipInUse: 0,
          };
        })
      );
      categoires.sort((a, b) => a.object.localeCompare(b.object));

      setContactCategories(categoires);
    });
  };

  return {
    contactCategories,
    isLoading,
    loadData,
  };
};
